/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_TemplateInputs */

const cs_property_ai_catalog_template = /** @type {(inputs: Property_Ai_Catalog_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona`)
};

const en_property_ai_catalog_template = /** @type {(inputs: Property_Ai_Catalog_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Property_Ai_Catalog_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_template = /** @type {((inputs?: Property_Ai_Catalog_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_template(inputs)
	return cs_property_ai_catalog_template(inputs)
});